<script>
import { mapGetters } from "vuex";
import Thumbnail from "./Thumbnail.vue";

export default {
  components: { Thumbnail },
  computed: { ...mapGetters(["isMaster", "getResultados"]) }
};
</script>

<template>
  <div v-if="isMaster" class="thumbnails">
    <div class="row">
      <div
        class="col-xs-12 col-sm-6 col-md-4"
        v-for="resultado in getResultados"
        :key="resultado.codigo"
      >
        <thumbnail :resultado="resultado"></thumbnail>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.thumbnails {
  > .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -8px;
    margin-left: -8px;

    > div {
      display: flex;
      padding-right: 8px;
      padding-left: 8px;
    }
  }
}
</style>